const QuestionnaireTypes = Object.freeze({
  EvaluacionServiciosTransicion: 1,
  EvaluacionServiciosEgresoPEI: 4,
  PrePruebaIntervencion: 5,
  PostPruebaIntervencion: 6,
  InventoryParent: 7,
  AsistenciaTecnologicaCalidadEducacion: 8,
  EvaluacionDeAsistenciaTecnologica: 9,
  InformacionDeSolicitudDeTransporte: 10,
});

export default QuestionnaireTypes;
